import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import {
  MenuItem,
  Select,
  TableSortLabel,
  SvgIcon,
  Tab,
} from "@material-ui/core";
import { visuallyHidden } from "@mui/utils";
import Box from "@mui/material/Box";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast, { Toaster } from "react-hot-toast";
import Typography from "@material-ui/core/Typography";

import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";
import IconButton from "@mui/material/IconButton";
import {
  Button,
  Grid,
  Menu,
  InputLabel,
  TextField,
  ListItemIcon,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import { useHistory, useLocation, Link } from "react-router-dom";
import {
  getDate,
  ViewCdtParticularPath,
  searchFilter,
  handleSort,
  getToday,
  getTime,
  editProspectPath,
  getDateTime,
  get12HoursTime,
  viewSalesReportsPath,
  ViewCDTyetToSubscribePath,
  viewmissalesreportsdetailsPath,
} from "../utils/varialbles";
import http from "../services/reportsPath";
import httpservices from "../services/httpService";

import SearchBar from "material-ui-search-bar";
// import Filter from '../components/filerComponent';
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
// import useFilter from "../components/filterComponent";
// import useFilter from "../components/multifilterComponent";
import useFilter from "../components/sideFilter";
import { textAlign } from "@mui/system";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditSharpIcon from "@material-ui/icons/EditSharp";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FormControl from "@material-ui/core/FormControl";
import DehazeIcon from "@material-ui/icons/Dehaze";
import MenuIcon from "@material-ui/icons/Menu";
import { PanoramaSharp } from "@material-ui/icons";
import { usePersistentState } from "react-persistent-state";

// import { browserHistory } from 'react-router'
import { browserHistory } from "react-router-dom";
import { createHashHistory } from "history";

const anchorEl = 1;
const setAnchorEl = 2;
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport csvOptions={{ allColumns: true }} />
    </GridToolbarContainer>
  );
}

let uniqueApiNames = {};

export default function ViewCdtReports() {
  const classes = useStyles();
  const [fromdate, setfromdate] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [fromDates, setFromDates] = useState("");
  const [finalColumnNames, setFinalColumnNames] = useState([]);
  const [rows, setRows] = useState([]);
  const [finalColumns, setFinalColumns] = useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  // const [anchorEl, setAnchorEl] = React.useState(false);
  const location = useLocation();
  const myparam = location.state;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const chistory = createHashHistory();
  // const isMenuOpen = Boolean(anchorEl);
  const form = {
    status: [],
    get_back_date: "",
    assigned_executive__empfname: "",
    cust__createddt: "",
    cust__createddt__condition: "lte",
    get_back_date__condition: "lte",
  };
  var dateUrl = "";

  const [formObject, setFormObject] = React.useState(form);
  let history = useHistory();
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };
  const [columns, setColumns] = useState([
    {
      headerName: "Name",
      id: "name",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "UserId",
      id: "userid",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Mobile",
      id: "mobile",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Email",
      id: "email",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Asset Class",
      id: "type",
      show: true,
      minWidth: 200,
      type: "array",
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Country",
      id: "country",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "First Date Of Advised",
      id: "date",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Portfolio Invested Amount",
      id: "investedval",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },

    {
      headerName: "Portfolio Advised Amount",
      id: "advisedval",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },

    {
      headerName: "Deviation",
      id: "deviation",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: " Portfolio Current Value",
      id: "currentval",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Absolute Profit/Loss",
      id: "gain",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "CAGR Return",
      id: "cagr",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Portfolio Return",
      id: "gainper",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Market Performance",
      id: "market",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Alpha",
      id: "alpha",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
  ]);
  const [statFilter, setStatFilter] = useState({
    from: "",
    to: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState([]);
  const [isFilterString, setIsFilterString] = useState(
    localStorage.getItem("selectedfiltersdata") || ""
  );
  const [isRange, setIsRange] = React.useState(false);

  const [isSelectedData, setIsSelectedDatas] = useState([
    {
      id: 1,
      options: [],
      name: "RM Name",
      type: "select",
    },
    {
      id: 2,
      data: { equalTo: "" },
      name: "Signed up Date Range",
      type: "date",
    },
    {
      id: 3,
      data: { equalTo: "" },
      name: "Subscription Date Range",
      type: "date",
    },
    {
      id: 4,
      options: [],
      name: "days",
      displayname: "Conversion Duration",
      type: "radio",
    },
  ]);

  const [locationSpecificColumn, setLocationSpecificColumn] = useState([]);

  const [prospectFlowColumns, setProspectFlowColumns] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Prospects Count",
      id: "total_prospects_count",
      show: true,
      minWidth: 200,
      type: "link",
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Attempted Count",
      id: "total_attempted_count",
      show: true,
      minWidth: 150,
      type: "link",
      align: "center",

      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Total Attempted Count in %",
      id: "total_attempted_per",
      show: true,
      minWidth: 150,
      align: "center",

      // headerAlign: "center",
    },
    {
      headerName: "Total Unattempted Count",
      id: "un_attempted_count",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Unattempted Count in %",
      id: "un_attemptedper",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Connected Count",
      id: "connected_count",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Connected Count in %",
      id: "connected_per",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Unconnected Count",
      id: "not_connected_count",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Unconnected Count in %",
      id: "not_connected_per",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total SavartX Count",
      id: "savartx_count",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total SavartX in %",
      id: "savartx_per",
      show: true,
      minWidth: 150,

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total SavartX3 Count",
      id: "savartx3_count",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total SavartX3 in %",
      id: "savartx3_per",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      align: "center",
    },
  ]);
  const [filterTrue, setFilterTrue] = useState(false);

  const [isFilterData, setIsFilterData] = useState([]);

  const [revenueColumns, setRevenueColumns] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Revenue",
      id: "Total_revenue",
      show: true,
      minWidth: 200,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Add Ons",
      id: "Addons",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Revenue From Prospects",
      id: "Revenue_prospects",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
  ]);
  const [refferalColumns, setRefferalColumns] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 200,
      type: "link",
      // headerAlign: "center",
      align: "center",
    },

    {
      headerName: "No of Referral Generated",
      id: "ref_generated",
      show: true,
      minWidth: 200,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Subscribed",
      id: "subscribed",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Yet To Subscribed",
      id: "yet_to_sub",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Revenue Generated",
      id: "revenue",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      align: "center",
    },
  ]);
  const [firstCallAfterPaymentColumns, setFirstCallAfterPaymentColumns] =
    useState([
      {
        headerName: "Date",
        id: "date",
        show: true,
        minWidth: 200,
        // type: "link"
        // headerAlign: "center",
        align: "center",
      },

      {
        headerName: "Calls Within 2 hrs.",
        id: "call_lessthan_2",
        show: true,
        minWidth: 200,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "2hrs - 4hrs",
        id: "call_range_2to4",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "4hrs - 8 hrs",
        id: "call_range_4to8",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
      {
        headerName: "Above 8hrs",
        id: "call_greaterthan_8",
        show: true,
        minWidth: 150,
        type: "link",

        // headerAlign: "center",
        align: "center",
      },
    ]);
  // const [onboardingCompletionColumns, setOnboardingCompletionColumns] = useState([

  //     {
  //         headerName: "Date",
  //         id: "date",
  //         show: true,
  //         minWidth: 200,
  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "No.of completed",
  //         id: "completed",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",
  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "No.of pending from same day subscribers",
  //         id: "same_day_pending",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "Other Days Pending",
  //         id: "others_day_pending",
  //         show: true,
  //         minWidth: 200,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },

  // ]);
  const [prospectsAgeColumns, setProspectsAgeColumns] = useState([
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "0 to 7 days",
      id: "-7",
      show: true,
      minWidth: 200,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "7 to 30 days",
      id: "7-30",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "30 to 90 days",
      id: "31-90",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Above 90 days",
      id: "90+",
      show: true,
      minWidth: 150,
      type: "link",

      // headerAlign: "center",
      align: "center",
    },
  ]);

  const [conversionReports, setConversionReports] = useState([
    {
      headerName: "Name",
      id: "fname",
      minWidth: "200",
      align: "left",
      format: "Name",
    },
    {
      headerName: "Mobile Number",
      id: "mobile",
      minWidth: "200",
      align: "center",
    },
    {
      headerName: "BGT Executive",
      id: "bgt",
      minWidth: "200",
      align: "center",
    },
    {
      headerName: "Signed Up Date",
      id: "signup_date",
      minWidth: "200",
      align: "center",
      format: "Datetime",
    },
    {
      headerName: "Subscription Date",
      id: "sub_date",
      minWidth: "200",
      align: "center",
      format: "Datetime",
    },
    {
      headerName: "Conversion",
      id: "conv",
      minWidth: "200",
      align: "center",
    },
  ]);

  const [paymentCols, setPaymentCols] = useState([
    {
      headerName: "S.No",
      id: "sno",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "User ID",
      id: "userID",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Mobile Number",
      id: "mob_num",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Date & Time of Creation",
      id: "timestamp",
      show: true,
      minWidth: 200,
      format: "date",
      // headerAlign: "center",
      align: "center",
    },
    // {
    //   headerName: "Time of creation",
    //   id: "datimestampte",
    //   show: true,
    //   minWidth: 200,
    //   format: "time",
    //   // headerAlign: "center",
    //   align: "center",
    // },
    {
      headerName: "Status",
      id: "status",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "No.of days from creation",
      id: "days",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Created by",
      id: "created_by",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Amount of payment",
      id: "amount",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "RM Name",
      id: "rm_name",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Product Name",
      id: "product",
      show: true,
      minWidth: 200,
      // type: "link"
      // headerAlign: "center",
      align: "center",
    },
  ]);

  // const [investorAgeColumns, setInvestorAgeColumns] = useState([
  //     {
  //         headerName: "Date",
  //         id: "date",
  //         show: true,
  //         minWidth: 200,
  //         // type: "link"
  //         // headerAlign: "center",
  //         align: "center",
  //     },

  //     {
  //         headerName: "0 to 30 days",
  //         id: "-30",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "30 to 90 days",
  //         id: "31-90",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "Above 90 days",
  //         id: "90+",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },

  // ]);
  // const [daysToRenewalColumns, setDaysToRenewalColumns] = useState([
  //     {
  //         headerName: "Date",
  //         id: "date",
  //         show: true,
  //         minWidth: 150,

  //         // type: "link"
  //         // headerAlign: "center",
  //         align: "center",
  //     },

  //     {
  //         headerName: "below 30 days",
  //         id: "-30",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "90 to 30 days",
  //         id: "91-30",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "Above 90 days",
  //         id: "90+",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },

  // ]);
  // const [clientWithZeroAdvicesColumns, setClientWithZeroAdvicesColumns] = useState([
  //     {
  //         headerName: "Date",
  //         id: "date",
  //         show: true,
  //         minWidth: 150,

  //         // type: "link"
  //         // headerAlign: "center",
  //         align: "center",
  //     },

  //     {
  //         headerName: "below 30 days",
  //         id: "-30",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "90 to 30 days",
  //         id: "91-30",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },
  //     {
  //         headerName: "Above 90 days",
  //         id: "90+",
  //         show: true,
  //         minWidth: 150,
  //         type: "link",

  //         // headerAlign: "center",
  //         align: "center",
  //     },

  // ]);
  // (columns);
  let staticCols = [
    "Alpha",
    "Advisedval",
    "Currentval",
    "Gainper",
    "Investedval",
  ];
  let finalDropCols = columns.filter((item) => {
    if (!staticCols.includes(item.headerName)) {
      return item.headerName;
    }
  });
  // (finalDropCols);

  const gridOptions = {
    filter: "false",
    pagination: false,
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  const [selected, setSelected] = useState([]);

  const requestSearching = () => {
    if (searched === undefined || searched.length < 4) {
      toast.error("Please Enter more than 3 characters to search");
    } else {
      getData(searched);
    }
  };

  const requestSearch = (searchedVal) => {
    setSearched(searchedVal);
    let rowsTemp = [...rows];

    if (searchedVal.length > 4) {
      myparam === 6
        ? setSearched(searchedVal)
        : setOriginalRows(searchFilter(searchedVal, rowsTemp)); // thisline is for front end pagination...
    }

    setPage(0);
  };

  // (searched);
  const cancelSearch = (searchVal) => {
    setSearched(searchVal);

    let abc = "";
    getData(abc);
  };
  // (searched, "out");

  const openFilter = (e) => {
    // let currentTarget = e.currentTarget;
    // (Boolean(currentTarget));
    // setAnchorEl(true);
    setIsMenuOpen(true);
    setIsFilterOpen(true);
  };

  // const [clearFilter, appliedFilter, setAppliedFilter, filterState, setFilterState, filterList, setFilterList, Filter, getFilterParams] = useFilter('prospect_manager');
  const [Filter, filterString, passFilters, passData] =
    useFilter("prospect_manager");
  // (filterString);

  const [totalRowCount, setTotalRowCount] = React.useState(0);

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;

    // var selectedRows=[...datas];
    // ('am datas', selectedRows);

    var retrievedObject = localStorage.getItem("testObject");
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const [filterStrings, setFilterStrings] = useState("");

  const getData = async (newQuery) => {
    toast.loading("Please wait...");

    const baseURL = uniqueApiNames.apiName;
    setOriginalRows([]);
    setRows([]);
    var https = http;
    if (myparam == 7) {
      https = httpservices;
    }
    https
      .get(getPaginationURL(baseURL, newQuery) + isFilterString)

      .then((response) => {
        toast.dismiss();
        // ("am data", response);
        // ("rowoow");
        // (response);
        // http.get("/investment_manager").then((response) => {
        if (
          response &&
          response.data &&
          response.data.statusCode === 0 &&
          Array.isArray(response.data.data)
        ) {
          // ("ooooooo");
          if (!filterStrings) passFilters(response.data.filter || []);

          let tempDta = response.data.data;
          setLocationSpecificColumn(response.data.countries);
          setOriginalRows(tempDta);
          setRows(response.data.data);
          if (response.data.filter !== undefined) {
            const datas = response.data.filter;

            let rawData = datas.map((es, index) => {
              es.id = index + 1;
              return es;
            });

            setIsFilterData(rawData);
          }
          // ("am raw data", isSelectedData);

          // setOriginalRows(response.data.data)

          let finalrows = tempDta.map((item) => {
            // (item);
            const obj = item;
            // (obj);

            const swapValue = (obj) => {
              Object.keys(obj).forEach((key) => {
                // if (!obj[key]) {
                //     obj[key] = "N/A";
                // }
              });
            };
            swapValue(obj);
            // (obj);
            return item;
          });

          let tempRows = [];
          // let tempTasks = tempDta.map(item=>item.custtasks);
          // setCustTask(tempTasks);

          let finalData = [];
          let tempStatusDta = tempDta.map((item, index) => {
            const swapValue = (item) => {
              Object.keys(item).forEach((key) => {
                //(Object.keys(item));
                // if (!item[key]) {
                //     item[key] = "N/A";
                // }
              });
            };
            swapValue(item);

            if (item.email === null) {
              finalData.push((item.email = "N/A"));
            } else {
              finalData.push(item.email);
            }

            if (item.cagr === null) {
              finalData.push((item.cagr = "N/A"));
            } else {
              finalData.push(item.cagr);
            }
            if (item.name === null) {
              finalData.push((item.name = "N/A"));
            } else {
              finalData.push(item.name);
            }

            finalData.push(
              (item.get_back_date = getDateTime(item.get_back_date))
            );
            finalData.push(
              (item.cust__createddt = getDateTime(item.cust__createddt))
            );
            finalData.push(
              (item.cust__last_login = getDateTime(item.cust__last_login))
            );
            finalData.push((item.custtasks = getDateTime(item.custtasks)));

            return item;
          });

          setOriginalRows(tempDta);
          setRows(tempDta);
          setTotalRowCount(response.data.totalRowCount);
        } else {
          setOriginalRows([]);
          setRows([]);
          setTotalRowCount(0);
        }
      });
  };

  const [counter, setcounter] = useState(0);
  // (counter);
  useEffect(() => {
    setcounter(counter + 1);

    // getData();
    // localStorage.setItem("selectedfiltersrevenuecdt", isFilterString);
    // localStorage.setItem("selectedfiltersdata", isFilterString);
    localStorage.setItem("misreportsrowsperpage", rowsPerPage);
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
    // localStorage.removeItem("prospectFilter");
    localStorage.removeItem("selectedfiltersdata");
    // localStorage.removeItem("selectedfiltersrevenuecdt");

    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }

    var getObj = JSON.parse(localStorage.getItem("cdtreportFilter"));
    // ('am local', getObj, isSelectedData);
    // for camparing the two arrays  and adding to the second array
    if (getObj !== null) {
      for (var e = 0; e < isSelectedData.length; e++) {
        if (isSelectedData[e]) {
          for (var f = 0; f < getObj.length; f++) {
            if (isSelectedData[e].id === getObj[f].id) {
              isSelectedData[e].options = getObj[f].options;
              // ("amv", isSelectedData)
            }
          }
        }
      }
      // applyFilters()
      // setIsFilterString(getFilterParams());
      // ('am filter strintv', isFilterString);
    } else {
    }

    if (filterTrue === true) {
      setIsFilterString(getFilterParams());
    } else {
    }
    let filtermatchString = getFilterParams();
    if (counter >= 2) {
      if (filtermatchString === isFilterString) {
        getData();
      }
    }
    const finalColumns = [
      {
        id: 0,
        columnName: locationSpecificColumn,
        apiName: "locationSpecificProspectCount",
        label: "",
      },
      {
        id: 1,
        columnName: prospectFlowColumns,
        apiName: "prospectFlow",
        label: "",
      },
      {
        id: 2,
        columnName: revenueColumns,
        apiName: "revenue",
        label: "",
      },
      {
        id: 3,
        columnName: refferalColumns,
        apiName: "referral",
        label: "",
      },
      {
        id: 4,
        columnName: firstCallAfterPaymentColumns,
        apiName: "cdt_firstcall",
        label: "",
      },
      // {
      //     id: 5,
      //     columnName: onboardingCompletionColumns,
      //     apiName: "onboardingCompletion"
      // },
      {
        id: 5,
        columnName: prospectsAgeColumns,
        apiName: "prospects_age",
        label: "prospectage",
      },
      // {
      //     id: 7,
      //     columnName: investorAgeColumns,
      //     apiName: "investors_age"
      // },
      // {
      //     id: 8,
      //     columnName: daysToRenewalColumns,
      //     apiName: "renewal_age"
      // },
      // {
      //     id: 9,
      //     columnName: clientWithZeroAdvicesColumns,
      //     apiName: "inactive"
      // }
      {
        id: 6,
        columnName: conversionReports,
        apiName: "client_conversion",
      },
      {
        id: 7,
        columnName: paymentCols,
        apiName: "getOverallPaymentLinkData",
      },
    ];
    // (myparam);
    const uniqueColumns = finalColumns.filter((ele) => {
      return ele.id === myparam;
    });

    const finalLabel = finalColumns.filter((item) => {
      return item.label;
    });

    setFinalColumnNames(uniqueColumns[0].columnName);

    uniqueApiNames = uniqueColumns[0];
  }, [appliedFilter, isFilterString, locationSpecificColumn]);
  // (locationSpecificColumn, 'finalColumnNames');

  useEffect(() => {
    getData();
  }, [page, rowsPerPage]);

  const handleColChange = (event) => {
    const value = event.target.value;
    // (value);
    setSelected(value);
    let newCols = columns.map((item) => {
      let findSelect = value.find((list) => {
        if (list === item.headerName) {
          // return item;
          item.show = true;
          // (item);
          return item;
          // setColumns(item);
        } else {
          item.show = false;
        }
      });
      return newCols;
    });

    // let parsedVal = JSON.parse(value);
    localStorage.setItem("slectProspectCols", value);
  };

  const dateHandleClear = () => {
    setStatFilter({
      from: "",
      to: "",
    });
  };

  const dateHandleChange = (e) => {
    setStatFilter({ ...statFilter, [e.target.name]: e.target.value });
  };
  const saveColumns = () => {
    let finalCols = staticCols.concat(selected);
    let sendFinalCols = [...new Set(finalCols)];
    // (finalCols);
    // (sendFinalCols);

    let finalObjet = {
      emp_id: localStorage.getItem("employee_id"),
      columns: sendFinalCols,
    };
    // ('am final object', finalObjet)

    http
      .post("/prospectempcolumns", finalObjet)
      .then((response) => {
        if (response.data.statusCode === 0) {
          toast.success(response.data.data);
          setShowMenuCol(false);
        } else {
          toast.error("Columns not saved!");
        }

        // setFromObject(form)
      })
      .catch((error) => {
        console.log("error");
      });
  };

  // (rows);
  // (orignalRows);

  const handleChangePage = (event, newPage) => {
    // (newPage);
    setPage(newPage);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setRows(finalRows);
    setPage(0);
  };

  //  const handleRequestSort = (event, property) => {
  //    const isAsc = orderBy === property && order === "asc";
  //    setOrder(isAsc ? "desc" : "asc");
  //    setOrderBy(property);
  //  };

  // const createSortHandler = (property) => (event) => {
  //   const onRequestSort = (event, property);
  // };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const viewProspectDetails = (date, country, row) => {
    // (row.key > 0);
    // object.page = page;
    const sendToparticularCDT = {
      date: date,
      country: country,
    };
    const sendToyetToSubscribeCDT = {
      date: date,
    };
    if (country === "ref_generated" || country === "yet_to_sub") {
      history.push(
        {
          pathname: ViewCDTyetToSubscribePath,
          state: sendToyetToSubscribeCDT,
          columnId: uniqueApiNames.id,
          cardName: location.cardName,
        },
        "_blank"
      );
    } else {
      history.push(
        {
          pathname: viewmissalesreportsdetailsPath,
          state: sendToparticularCDT,
          columnId: uniqueApiNames.id,
          cardName: location.cardName,
          // pathname:ViewCdtParticularPath
        },
        "_blank"
      );
    }
  };

  // (myparam);

  const editProspect = (object) => {
    // (object);
    object.page = page;

    history.push({
      pathname: editProspectPath,
      state: object,
    });
  };

  const [menuCol, setShowMenuCol] = useState(false);

  // (columns);

  const gotoMisresearchCards = () => {
    localStorage.removeItem("cdtreportFilter");
    history.push({
      pathname: viewSalesReportsPath,
      // pathname: viewSalesReportsPath
    });
  };
  const dateHandleApply = () => {
    if (statFilter.from !== "" && !statFilter.to !== "") {
      dateUrl = `?from=${statFilter.from}&to=${statFilter.to}`;
      toast.loading("Please wait...");
      http
        .get(`/revenue${dateUrl}`)
        .then((res) => {
          toast.dismiss();
          // setListData(res.data.Data);
          setOriginalRows(res.data.data);
          setStatFilter({
            from: "",
            to: "",
          });
          // setNameDropdown(res.data.names);
        })
        .catch((err) => {});
      setIsFilterOpen(false);
    } else {
      dateUrl = "";
      toast.error("Please fill all the fields");
    }
  };

  const handleSelectChange = (v, id, meta) => {
    // ("am ", v, id);
    if (v === "range") {
      setIsRange(true);
    } else {
      // setIsRange(false);
    }
    setIsSelectedDatas((fstate) => {
      const newState = isFilterData.map((x) => {
        if (x.id === id) {
          //check the type and add value according to the value.
          // if(x.type === 'number'){
          //     return ({
          //         name: x.name,
          //         id: x.id,
          //         value: parseFloat(v),
          //         // options: v
          //     })
          // }

          if (x.type === "select") {
            return {
              name: x.name,
              id: x.id,
              options: v,
            };
          } else if (x.type === "radio") {
            return {
              name: x.name,
              id: x.id,
              options: [v],
            };
          } else if (x.type === "date" || x.type === "number") {
            setfromdate(true);
            if (meta === "option") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              let currentValue = fstateObject.data.lessThan
                ? fstateObject.data.lessThan
                : "";
              currentValue = fstateObject.data.greaterThan
                ? fstateObject.data.greaterThan
                : "";
              currentValue = fstateObject.data.equalTo
                ? fstateObject.data.equalTo
                : "";
              currentValue = fstateObject.data.greaterThanEqual
                ? fstateObject.data.greaterThanEqual
                : "";
              currentValue = fstateObject.data.lessThanEqual
                ? fstateObject.data.lessThanEqual
                : "";
              currentValue = fstateObject.data.range
                ? fstateObject.data.range
                : "";
              // (currentValue);
              return { id, name: x.name, data: { [v]: currentValue } };
            } else if (meta === "value") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              return { id, name: x.name, data: { [currentOption]: v } };
            } else if (meta === "rangeFrom") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue =
                fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(",")) {
                const fromValue = currentValue.split(",")[0];
                const toValue = currentValue.split(",")[1];
                const encodedDate = `${v},${toValue}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              } else {
                const encodedDate = `${v},`;
                // (currentValue, v, encodedDate)
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              }
            } else if (meta === "rangeTo") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue =
                fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(",")) {
                const fromValue = currentValue.split(",")[0];
                const toValue = currentValue.split(",")[1];
                const encodedDate = `${fromValue},${v}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              } else {
                const encodedDate = `,${v}`;
                // (currentValue, v, encodedDate)
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              }
            }
          }
        } else {
          return fstate.find((filter) => filter.id === x.id);
        }
      });
      return newState;
    });
  };

  // changing the filter params to sending to the backend
  const getFilterParams = () => {
    //convert the appliedFilterState to query params string (without ? mark) using the following convertion format
    // status - comma separated values, name is Status in the object
    // RM - comma separated values, name is RM Name in the object
    // signup_lt - less than signup date - date format, name is Signup Date and lessThan property is present with date
    // signup_gt - greater than signup date -date format, name is SignupDate and greaterThan property is present with date
    // getback_lt - less than get back date - date format, name is Get Back Date and lessThan property is present with date
    // getback_gt - greater than get back date -date format name is Get Back Date and greaterThan property is present with date
    // convert appliedFilterState to query params string
    // appliedFilterState contains objects with properties: name, options[ARRAY] (or data[OBJECT] for time)

    const conversionFormatFor_select = {
      "RM Name": "name",
      days: "days",
      // "RM name": "rm_name", // This is commenting for Prospect Overview Filter Fix
      "BGT Name": "bgt_name",
      BGT: "BGT",
      CDT: "CDT",
      Status: "status",
      "Prospect Source": "cust__signupfrom__in",
      "Service Type": "serviceType",
      "Referee Visits": "refree_visits",
      "Successful referrals": "success_refs",
      "Referrals Shared": "ref_shared",
      "Referral Bonus": "ref_bonus",
      "Issue Type": "issueType",
      Reporter: "reporter",
      "Assigned To": "assignedTo",
      Severity: "severity",
      Frequency: "frequency",
      "Preferred Language": "language",
      "Critical CDT Reminders": "ccdtReminders",
      "Subscription Status": "subscription_status",
      Conditions: "filter_data",
      "KYC Status": "kyc_status",
      // "Personal profile Status": "pp_status",
      "Personal Profile Status": "pp_status",
      "Demat Link": "demat_link",
      "Task Status": "task_status",
      Country: "cust__custcountry__locname__in",
      City: "cust__custcity__in",
      State: "cust__custstate__in",
      "Personal Profile": "pp_status",
      KYC: "kyc_status",
      Goal: "goal_status",
    };
    const conversionFormatFor_date = {
      "Signed up Date Range": "signup",
      "Subscription Date Range": "sub",
      "Expiry Date": "expiryDate_",
      // "Sign up date": "signup_", // This is commenting for Prospect Overview Filter Fix
      "Get Back Date": "getback_",
      "Created Date": "createdDate_",
      "Call Date": "callDate_",
      "Date Time": "callDate_",
      // "Referrals Shared": "ref_shared_",
      "Renewal Date": "renewaldt_",

      "Last Activity date": "cust__custlastactivity__", // This is commenting for Investment Overview Filter Fix
      "Last Login Date": "cust__last_login__",
      "Goals set": "goals_set_value_",
      ref_shared_value: "ref_shared_value_",
      ref_bonus_value: "ref_bonus_value_",
      refree_visits_value: "refree_visits_value_",
      success_refs_value: "success_refs_value_",
      "Goals set": "goals_set_",
    };
    const conversionFormatFor_number = {
      // "Goals set" : "goals_set_value_"
      // "ref_shared_value": "ref_shared_value",
      // "ref_bonus_value" : "ref_bonus_value",
      // "refree_visits_value": "refree_visits_value",
      // "success_refs_value": "success_refs_value"
    };

    const filterParams = {};

    appliedFilter.map((filter) => {
      if (filter.options) {
        // condition it based on type of filter rather than options or data props

        filterParams[conversionFormatFor_select[filter.name]] = filter.options
          .map((x) => x)
          .join(",");
      } else if (filter.data) {
        let suffix;
        if (Object.keys(filter.data)[0] === "greaterThan") {
          suffix = "gt";
        } else if (Object.keys(filter.data)[0] === "lessThan") {
          suffix = "lt";
        } else if (Object.keys(filter.data)[0] === "equalTo") {
          suffix = "";
        } else if (Object.keys(filter.data)[0] === "lessThanEqual") {
          suffix = "date__lte";
        } else if (Object.keys(filter.data)[0] === "greaterThanEqual") {
          suffix = "gte";
        } else if (Object.keys(filter.data)[0] === "range") {
          suffix = "";
        }

        filterParams[conversionFormatFor_date[filter.name] + suffix] =
          filter.data[Object.keys(filter.data)[0]];
      }
      // else if(filter.value){
      //     filterParams[conversionFormatFor_number[filter.name]] = filter.value;
      // }
    });
    //return the query string with the filterParams
    const params = Object.keys(filterParams)
      .map((x) => x + "=" + filterParams[x])
      .join("&");
    return params ? "&" + params : "";
  };

  const parseRangeValue = (doubleDate, fromTo) => {
    // (doubleDate);
    // (fromTo);
    // value={parseRangeValue(filterState.find(x=>x.id===filter.id)?.data[Object.keys(filterState.find(x=>x.id===filter.id)?.data || {})[0]])}
    // doubleDate Format is 2020-05-30,2020-07-31

    if (fromTo === "from") {
      return doubleDate.split(",")[0];
    } else {
      return doubleDate.split(",")[1];
    }
  };

  const shouldNameDisplay = (filter) => {
    // const exceptionCase = location.url
    // (filter);
    return filter.showName
      ? filter.name === "days"
        ? "Conversion Duration"
        : filter.name
      : "";
  };

  const [showFilter, setShowFilter] = useState(false);

  const showMenuFilter = () => {
    setShowFilter((val) => !val);
  };

  const closeFilter = () => {
    setShowFilter(false);
  };

  const [filterVal, setFilterVal] = useState({
    fromDate: "",
    toDate: "",
  });

  let { fromDate, toDate } = filterVal;

  var string = "&fromdate=" + fromDate + "&todate=" + toDate;
  const handleChangeFilter = (e) => {
    setFilterVal({ ...filterVal, [e.target.name]: e.target.value });
  };

  const applyFilter = () => {
    setFilterTrue(true);
    const cleanedFilterState = isSelectedData.filter((x) => {
      if (x.options) {
        // for select and radios
        return x.options.length > 0;
      } else if (x.data) {
        // for date
        return (
          x.data.greaterThan ||
          x.data.lessThan ||
          x.data.equalTo ||
          x.data.lessThanEqual ||
          x.data.greaterThanEqual ||
          x.data.range
        );
      } else if (x.value) {
        // for number type
        //x.value is a number u cant get length of it
        return x.value.toString().length > 0;
      }
      // (x);
    });

    localStorage.setItem("cdtreportFilter", JSON.stringify(cleanedFilterState));

    setAppliedFilter(cleanedFilterState);
    if (appliedFilter !== 0) {
      appliedFilter.map((x) => {
        if (x.type === "select" || x.type === "radio") {
          const selectFilerobject = {
            id: x.id,
            options: [x.options],
            name: x.name,
          };
          isSelectedData.push(selectFilerobject);
        } else if (x.type === "date" || x.type === "number") {
          // var today = new Date();
          const emptyFilterObject = {
            id: x.id,
            data: {
              equalTo: "",
            },
            name: x.name,
          };
          isSelectedData.push(emptyFilterObject);
        }
      });
    }
    setIsFilterString(getFilterParams());

    // ("filter");
    // props.setOpen(false);
    setIsFilterOpen(false);
    // getData()
  };
  // const[empty,setempty]=useState({});

  const clearFilter = () => {
    //     setFilterStrings("");
    //     setFromDates("");
    //     const fromdate = document.getElementById("fromDate");
    //     fromdate.value = "";
    //     fromDate = "";
    //     const todate = document.getElementById("toDate");
    //     todate.value = "";
    //     toDate = "";

    setIsSelectedDatas([
      {
        id: 1,
        options: [],
        name: "RM Name",
      },
      {
        id: 2,
        data: { range: "" },
        name: "Signed up Date Range",
      },
      {
        id: 3,
        data: { range: "" },
        name: "Subscription Date Range",
      },
      {
        id: 4,
        options: [],
        name: "days",
      },
    ]);

    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("cdtreportFilter");
    setfromdate(false);
  };

  return (
    <>
      <Grid container style={{ marginTop: "10px" }}>
        <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoMisresearchCards}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
          <Typography variant="h5" style={{ margin: "0px 0px 20px 20px" }}>
            {location.cardName}
          </Typography>
        </Grid>
      </Grid>
      <></>

      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={(searchVal) => cancelSearch(searchVal)}
              onRequestSearch={requestSearching}
            />
            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: "10px", borderRadius: "20px" }}
              onClick={requestSearching}
              disabled={!searched}
            >
              Search
            </Button>
          </div>

          <div container>
            <div>
              <TablePagination
                rowsPerPageOptions={[10, 50, 100, 500]}
                component="div"
                count={myparam !== 6 ? orignalRows.length : totalRowCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                // style={{width:'27rem'}}
              />
            </div>
          </div>
          {/* <div style={{ display: "flex", cursor: "pointer" }}>

                        <span onClick={showMenuFilter}>
                            Columns

                        </span>
                        <FormControl className={classes.formControl}>

                            {menuCol ? (
                                <div style={{ display: "flex" }}>
                                    <Select
                                        labelId="mutiple-select-label"
                                        multiple
                                        value={selected}
                                        onChange={handleColChange}
                                        // renderValue={(selected) => selected.join(", ")}
                                        renderValue={(selected) => null}
                                        MenuProps={MenuProps}
                                    >
                                        {finalDropCols.map((option) => (
                                            <MenuItem
                                                key={option.headerName}
                                                value={option.headerName}
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        checked={selected.indexOf(option.headerName) > -1}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText primary={option.headerName} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Button
                                        style={{ marginLeft: "10px" }}
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        onClick={saveColumns}
                                    >
                                        Save
                                    </Button>
                                </div>
                            ) : (
                                <>
                                    <FilterListSharpIcon
                                        style={{ marginTop: 0 }}
                                        onClick={showMenuFilter}
                                    />

                                </>

                            )}
                        </FormControl>
                    </div> */}

          <div
            style={{ display: "flex", position: "relative" }}
            className="tfilter"
          >
            <div>
              <span style={{ margin: "0px 15px" }}>
                Filter
                <SvgIcon
                  style={{
                    cursor: "pointer",
                    verticalAlign: "middle",
                    marginLeft: "5px",
                  }}
                  onClick={showMenuFilter}
                  title={"filter"}
                >
                  <FilterLogo />
                </SvgIcon>
              </span>
              {showFilter ? (
                <div
                  className={[
                    "newfilterstyle",
                    "menupopupfilter",
                    "filter",
                  ].join(" ")}
                  style={{ padding: "20px" }}
                >
                  {/* {('am fun', isSelectedData)} */}
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      lineHeight: "30px",
                      display: "flex",
                      justifyContent: "center",
                      fontWeight: "bold",
                      cursor: "pointer",
                      background: "#ddd",
                      margin: "5px 0 0 5px",
                      textAlign: "right",
                      float: "right",
                    }}
                    onClick={closeFilter}
                  >
                    X
                  </div>

                  {isFilterData.map((filter, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          marginLeft: 20,
                          paddingBottom: 10,
                          paddingTop: 10,
                        }}
                      >
                        <div>
                          <InputLabel style={{ color: "black" }}>
                            {shouldNameDisplay(filter)}
                          </InputLabel>
                        </div>

                        <div style={{ paddingTop: 10 }}>
                          {filter.type === "select" ? (
                            <>
                              <Select
                                labelId="mutiple-select-label"
                                displayEmpty
                                className="select"
                                variant="outlined"
                                multiple
                                style={{ paddingLeft: "5px" }}
                                value={
                                  isSelectedData.find((x) => {
                                    return x.id === filter.id;
                                  })?.options || []
                                }
                                name={filter.name}
                                onChange={(e) => {
                                  handleSelectChange(e.target.value, filter.id);
                                }}
                                // renderValue={(selectedDatas) => selectedDatas.join(", ")}
                                renderValue={(selected) => {
                                  return selected
                                    .map(
                                      (s) =>
                                        filter.options.find(
                                          (x) => x.value === s
                                        )?.name
                                    )
                                    .join(", ");
                                }}

                                // MenuProps={MenuProps}
                              >
                                {filter.options.map((option, index) => (
                                  <MenuItem key={index} value={option.value}>
                                    <ListItemText primary={option.name} />
                                    <ListItemIcon>
                                      <Checkbox
                                        classes={{
                                          root: classes.radio,
                                          checked: classes.checked,
                                        }}
                                        checked={
                                          isSelectedData
                                            .find((x) => x.id === filter.id)
                                            ?.options.indexOf(option.value) !==
                                          -1
                                            ? true
                                            : false
                                        }
                                        style={{ paddingLeft: "5px" }}
                                      />
                                    </ListItemIcon>
                                  </MenuItem>
                                ))}
                              </Select>
                            </>
                          ) : filter.type === "radio" ? (
                            <>
                              <Select
                                displayEmpty
                                value={
                                  isSelectedData.find((x) => {
                                    return x.id === filter.id;
                                  })?.options
                                }
                                onChange={(e) => {
                                  handleSelectChange(e.target.value, filter.id);
                                }}
                                name={filter.name}
                                className="select"
                                variant="outlined"
                                style={{
                                  backgroundColor: "white",
                                }}
                              >
                                <MenuItem value="">Select</MenuItem>
                                {filter.options.map((option, index) => {
                                  return (
                                    <MenuItem key={index} value={option.value}>
                                      <ListItemText primary={option.name} />
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </>
                          ) : filter.type === "date" ? (
                            <>
                              {/* <Select
                                value={
                                  Object.keys(
                                    isSelectedData.find((x) => {
                                      return x.id === filter.id;
                                    })?.data || {}
                                  )[0]
                                }
                                onChange={(x) =>
                                  handleSelectChange(
                                    x.target.value,
                                    filter.id,
                                    "option"
                                  )
                                }
                                className="select"
                                label={filter.name}
                                style={{
                                  backgroundColor: "white",
                                  marginBottom: "10px",
                                }}
                                variant="outlined"
                              >
                                <MenuItem value={"equalTo"}>Equal To</MenuItem>
                                <MenuItem value={"lessThan"}>
                                  Less Than
                                </MenuItem>
                                <MenuItem value={"greaterThan"}>
                                  Greater Than
                                </MenuItem>
                                <MenuItem value={"lessThanEqual"}>
                                  Less Than Equal To
                                </MenuItem>
                                <MenuItem value={"greaterThanEqual"}>
                                  Greater Than Equal To
                                </MenuItem>
                                <MenuItem value={"range"}>Range</MenuItem>
                              </Select> */}
                              {/* {Object.keys(
                                isSelectedData.find((x) => {
                                  return x.id === filter.id;
                                })?.data || {}
                              )[0] !== "range" ? (
                                <TextField
                                  type="date"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data[
                                      Object.keys(
                                        isSelectedData.find(
                                          (x) => x.id === filter.id
                                        )?.data || {}
                                      )[0]
                                    ]
                                  }
                                  onChange={(x) =>
                                    handleSelectChange(
                                      x.target.value,
                                      filter.id,
                                      "value"
                                    )
                                  }
                                  // inputProps={{
                                  //   style: {
                                  //     paddingLeft: 5,
                                  //   },
                                  // }}
                                  className="select"
                                  style={{
                                    backgroundColor: "white",
                                  }}
                                />
                              ) : ( */}
                              {/* // RANGE FIELDS */}
                              <>
                                <label
                                  style={{
                                    fontSize: 11,
                                    marginBorrom: 10,
                                    display: "block",
                                  }}
                                >
                                  {" "}
                                  From{" "}
                                </label>
                                <TextField
                                  type="date"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                  value={parseRangeValue(
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data[
                                      Object.keys(
                                        isSelectedData.find(
                                          (x) => x.id === filter.id
                                        )?.data || {}
                                      )[0]
                                    ],
                                    "from"
                                  )}
                                  onChange={(x) =>
                                    handleSelectChange(
                                      x.target.value,
                                      filter.id,
                                      "rangeFrom"
                                    )
                                  }
                                  className="select"
                                  style={{
                                    backgroundColor: "white",
                                  }}
                                />
                                {fromdate === true ? (
                                  <>
                                    <label
                                      style={{
                                        fontSize: 11,
                                        marginBorrom: 10,
                                        display: "block",
                                      }}
                                    >
                                      {" "}
                                      To{" "}
                                    </label>
                                    <TextField
                                      type="date"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{
                                        max: new Date()
                                          .toISOString()
                                          .split("T")[0],
                                      }}
                                      value={parseRangeValue(
                                        isSelectedData.find(
                                          (x) => x.id === filter.id
                                        )?.data[
                                          Object.keys(
                                            isSelectedData.find(
                                              (x) => x.id === filter.id
                                            )?.data || {}
                                          )[0]
                                        ],
                                        "to"
                                      )}
                                      onChange={(x) =>
                                        handleSelectChange(
                                          x.target.value,
                                          filter.id,
                                          "rangeTo"
                                        )
                                      }
                                      className="select"
                                      style={{
                                        backgroundColor: "white",
                                      }}
                                    />{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                              {/* )} */}
                            </>
                          ) : filter.type === "number" ? (
                            <>
                              <select
                                value={
                                  Object.keys(
                                    isSelectedData.find((x) => {
                                      return x.id === filter.id;
                                    })?.data || {}
                                  )[0]
                                }
                                onChange={(x) =>
                                  handleSelectChange(
                                    x.target.value,
                                    filter.id,
                                    "option"
                                  )
                                }
                                className="select"
                                label={filter.name}
                                style={{
                                  backgroundColor: "white",
                                  marginBottom: 10,
                                }}
                              >
                                <option value={"equalTo"}>Equal To</option>
                                <option value={"lessThan"}>Less Than</option>
                                <option value={"greaterThan"}>
                                  Greater Than
                                </option>
                                <option value={"lessThanEqual"}>
                                  Less Than Equal To
                                </option>
                                <option value={"greaterThanEqual"}>
                                  Greater Than Equal To
                                </option>
                                <option value={"range"}>Range</option>
                              </select>
                              {/* {// ('test1', filter.id)}
                  {// (filterState.find(x=>{// (x);return x.id===filter.id}))}
                  {// ('test2')} */}
                              {Object.keys(
                                isSelectedData.find((x) => {
                                  return x.id === filter.id;
                                })?.data || {}
                              )[0] !== "range" ? (
                                <TextField
                                  type="text"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data[
                                      Object.keys(
                                        isSelectedData.find(
                                          (x) => x.id === filter.id
                                        )?.data || {}
                                      )[0]
                                    ]
                                  }
                                  onChange={(x) =>
                                    handleSelectChange(
                                      x.target.value,
                                      filter.id,
                                      "value"
                                    )
                                  }
                                  className="select"
                                  style={{
                                    backgroundColor: "white",
                                  }}
                                />
                              ) : (
                                // RANGE FIELDS
                                <>
                                  <label
                                    style={{
                                      fontSize: 11,
                                      marginBorrom: 10,
                                      display: "block",
                                    }}
                                  >
                                    {" "}
                                    From{" "}
                                  </label>
                                  <TextField
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={parseRangeValue(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data[
                                        Object.keys(
                                          isSelectedData.find(
                                            (x) => x.id === filter.id
                                          )?.data || {}
                                        )[0]
                                      ],
                                      "from"
                                    )}
                                    onChange={(x) =>
                                      handleSelectChange(
                                        x.target.value,
                                        filter.id,
                                        "rangeFrom"
                                      )
                                    }
                                    className="select"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  />
                                  <label
                                    style={{
                                      fontSize: 11,
                                      marginBorrom: 10,
                                      display: "block",
                                    }}
                                  >
                                    {" "}
                                    To{" "}
                                  </label>
                                  <TextField
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={parseRangeValue(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data[
                                        Object.keys(
                                          isSelectedData.find(
                                            (x) => x.id === filter.id
                                          )?.data || {}
                                        )[0]
                                      ],
                                      "to"
                                    )}
                                    onChange={(x) =>
                                      handleSelectChange(
                                        x.target.value,
                                        filter.id,
                                        "rangeTo"
                                      )
                                    }
                                    className="select"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  />
                                </>
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {/* <div>
                    <h1>Date</h1>
                    <label>From</label>
                    <br />
                    <br />
                    <input
                      type="date"
                      name="fromDate"
                      id="fromDate"
                      //  onChange={handleChangeFilter}
                      value={fromDates}
                      onChange={(e) => setFromDates(e.target.value)}
                      style={{
                        width: "80%",
                        height: "40px",
                        border: "transparent",
                        marginLeft: "10px",
                        fontSize: "18px",
                      }}
                    />
                    <br />
                    <br />
                    <br />
                    <label>To</label>
                    <br />
                    <br />
                    <input
                      type="date"
                      name="toDate"
                      id="toDate"
                      onChange={handleChangeFilter}
                      style={{
                        width: "80%",
                        height: "40px",
                        border: "transparent",
                        marginLeft: "10px",
                        fontSize: "18px",
                      }}
                    />
                    <br />
                    <br />
                    <br />
                    <br />
                                    </div> */}

                  <div
                    style={{
                      float: "right",
                      paddingBottom: 10,
                      paddingRight: 40,
                      paddingTop: 10,
                      display: "flex",
                      justifyContent: "flex-end",
                      columnGap: 20,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={clearFilter}
                      color="default"
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      onClick={applyFilter}
                      color="primary"
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {/* <MaterialTable
        columns={columns}
        data={orignalRows}
        style={{ fontSize: 12 }}
        onRowClick={(event, rowData) => viewProspectDetails(rowData)}
        options={{ filtering: false, columnsButton: true, search: false, paging: false, pageSizeOptions: [10, 50, 100, 500], actionsColumnIndex: -1, fixedColumns:{left:2} selection: true }}
        title=""
      /> */}

        {/* <DataGrid
                    columns={filteredCol}
                    rows={orignalRows}
                    getRowId={(row) => row.userid}
                    // pageSize={5}
                    // rowsPerPageOptions={false}
                    // checkboxSelection
                    //onRowClick={(event, rowData) => viewProspectDetails(rowData)}
                    style={{ cursor: "pointer" }}
                    onRowDoubleClick={(param) => viewProspectDetails(param.row)}
                    options={gridOptions}
                    autoHeight
                // components={{
                //   Toolbar: CustomToolbar,
                // }}
                // initialState={{ pinnedColumns: { left: ['actions']} }}
                /> */}

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {finalColumnNames.map((column, index) => (
                  <TableCell
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                    sortDirection={orderBy === column.index ? order : false}
                  >
                    {/* <TableSortLabel
                      active={orderBy === column.index}
                      direction={orderBy === column.index ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.index, column.format)
                      }
                      // onClick={handleRequestSort(column.index)}
                    >
                      {column.headerName}
                      {orderBy === column.index ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </TableSortLabel> */}
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {myparam === 6 ? (
              <TableBody>
                {orignalRows.length !== 0 ? (
                  <>
                    {orignalRows.map((row) => {
                      return (
                        <TableRow>
                          {finalColumnNames.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                align={column.align}
                                style={{
                                  padding: value === 0 ? "18px" : "18px",
                                  textAlign: "center",
                                }}
                              >
                                {column.format === "Datetime" ? (
                                  getDateTime(value)
                                ) : column.format === "Name" ? (
                                  <div style={{ textAlign: "left" }}>
                                    {value + " " + row.lname}
                                  </div>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </>
                ) : (
                  <TableCell
                    colspan="9"
                    style={{ "text-align": "center", margin: "10px 0px" }}
                  >
                    Records Not Available
                  </TableCell>
                )}
              </TableBody>
            ) : (
              <TableBody>
                {orignalRows.length !== 0 ? (
                  <>
                    {orignalRows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index + "a"}
                            // className='prospecttable'
                            // onDoubleClick={() =>
                            //     // viewProspectDetails(row)
                            //     if (uniqueApiNames.id === 2) {
                            //     viewProspectDetails(row)
                            // }

                            // else {

                            // }

                            // }
                          >
                            {finalColumnNames.map((column, index) => {
                              const value = row[column.id];

                              return (
                                <TableCell
                                  key={index}
                                  align={column.align}
                                  style={{
                                    padding: value === 0 ? "18px" : "18px",
                                    textAlign: "center",
                                  }}
                                  // style={{
                                  // value? {'padding:'18px' }: {""}}}

                                  // onDoubleClick={() => viewProspectDetails(row)}
                                >
                                  {column.format &&
                                  typeof value === "number" ? (
                                    column.format(value)
                                  ) : column.id === "type" &&
                                    value.length !== 0 ? (
                                    <>
                                      {Array.isArray(value)
                                        ? value.join(",")
                                        : "N/A"}
                                    </>
                                  ) : column.format === "Date" ? (
                                    getDate(value)
                                  ) : column.operation &&
                                    column.operation === "concate" ? (
                                    value + column.operand + row[column.with]
                                  ) : column.type &&
                                    column.type === "link" &&
                                    value ? (
                                    <p
                                      style={{
                                        margin: "0px",
                                        padding: "18px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                      }}
                                      variant="body2"
                                      // onClick={(e) => viewDetails(row)}
                                      onDoubleClick={(e) =>
                                        viewProspectDetails(
                                          row.date,
                                          column.id,
                                          row
                                        )
                                      }
                                      gutterBottom
                                      // style={{ cursor: "pointer", color: "black", textDecoration: 'none' }}
                                    >
                                      {value}
                                    </p>
                                  ) : column.type &&
                                    column.type === "attach" &&
                                    value ? (
                                    <Link
                                      // href={staticFiles + value}
                                      target="_blank"
                                      variant="body2"
                                      gutterBottom
                                      style={{ cursor: "pointer" }}
                                    >
                                      {value}
                                    </Link>
                                  ) : column.format === "Datetime" ||
                                    column.format === "date" ? (
                                    getDateTime(value)
                                  ) : column.format === "Name" ? (
                                    <div style={{ textAlign: "left" }}>
                                      {value + " " + row.lname}
                                    </div>
                                  ) : value === null ? (
                                    <div>N/A</div>
                                  ) : (
                                    value
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </>
                ) : (
                  <TableCell
                    colspan="6"
                    style={{ "text-align": "center", margin: "10px 0px" }}
                  >
                    Records Not Available
                  </TableCell>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <div>
          {/* <tab />   // Need To Comment This           */}
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            count={myparam !== 6 ? orignalRows.length : totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // style={{width:'27rem'}}
          />
        </div>
      </Paper>
    </>
  );
}
